module.exports = __webpack_public_path__ + "images/f8db9633.www_1_cht.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintro/www_1_cht.png
// module id = 530
// module chunks = 0